/*
 * Ouvre l'onglet depliant vise par une ancre.
 *
 * Un fragment d'URL ne deplie pas un <details> de maniere fiable selon les
 * navigateurs : on force donc l'ouverture au clic sur un lien interne, a
 * l'arrivee sur la page avec un fragment, et sur tout changement de fragment.
 *
 * L'ecouteur est pose sur le document plutot que sur chaque lien : les
 * sections sont remplacees par innerHTML a chaque changement de variante, des
 * ecouteurs poses sur les liens eux-memes seraient perdus.
 */
(function () {
  function targetFromHash(hash) {
    if (!hash || hash.charAt(0) !== '#') return null;
    const target = document.getElementById(hash.slice(1));
    return target && target.tagName === 'DETAILS' ? target : null;
  }

  function openFromHash(hash) {
    const target = targetFromHash(hash);
    if (target) target.open = true;
    return target;
  }

  document.addEventListener('click', function (event) {
    const link = event.target.closest && event.target.closest('a[href^="#Accordion-"]');
    if (!link) return;

    const hash = link.getAttribute('href');
    const target = openFromHash(hash);
    if (!target) return;

    // On reprend le defilement a notre compte : le saut natif ignore
    // l'en-tete collant et laisse l'onglet cache dessous. scrollIntoView
    // respecte le scroll-margin-top pose en CSS.
    event.preventDefault();
    target.scrollIntoView({ behavior: 'smooth', block: 'start' });
    // replaceState plutot que l'ancre : l'URL reflete la cible sans declencher
    // un second saut par-dessus notre defilement.
    if (window.history && window.history.replaceState) {
      window.history.replaceState(null, '', hash);
    }
  });

  window.addEventListener('hashchange', function () {
    openFromHash(window.location.hash);
  });

  openFromHash(window.location.hash);
})();
